import React, { useEffect, useState } from "react"
import { Switch } from "react-router-dom"
import router from "../router.js"
import { PrivateRoute } from "../components/shared/PrivateRoute"

const generateRouter = routes => {
  return routes.map((prop, key) => {
    if (prop.component) {
      return {
        roles: prop.roles,
        path: prop.path,
        component: prop.component,
        key: key
      }
    } else {
      if (prop.children) {
        return generateRouter(prop.children)
      } else {
        return ""
      }
    }
  })
}

const SwitchRouter = () => {
  const [routeList, setRouteList] = useState(null)
  useEffect(() => {
    setRouteList(generateRouter(router))
  }, [])

  return (
    <>
      {routeList && (
        <Switch>
          {routeList.map((item, index) => {
            return (
              <PrivateRoute
                exact
                roles={item.roles}
                path={item.path}
                component={item.component}
                key={index}
              />
            )
          })}
        </Switch>
      )}
    </>
  )
}
export default SwitchRouter
